import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from "../gelios-field-base/gelios-field-base.component";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-fancy-boolean-field',
  templateUrl: './gelios-fancy-boolean-field.component.html',
})
export class GeliosFancyBooleanFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}
